import { createContainer, createHook, createStore } from 'react-sweet-state';
import { actions } from './actions';
import { initialState } from './state';
export const ResponderNamesStore = createStore({
  initialState: initialState,
  actions,
  name: 'ResponderNamesStore'
});
export const ResponderNamesContainer = createContainer(ResponderNamesStore);
export const useResponderNamesStore = createHook(ResponderNamesStore);